import { t } from '@/i18n';
import { z } from 'zod';

export const modalFormSchema = z.object({
  names: z
    .array(
      z.object({
        name: z.string().min(1, t('pages.application_won_title.components.competition_edit_modal.schema.required')),
      }),
    )
    .default([])
    .optional(),
});

export type ModalFormData = z.infer<typeof modalFormSchema>;
